import React from "react";
import styled from "styled-components";

import Spin from "antd/lib/spin";

const Loader = () => {
  return (
    <ForceCenter>
      <Spin size='large' />
    </ForceCenter>
  );
};

export default Loader;

const ForceCenter = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
